import { Html } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as THREE from "three";
import JupiterModel from "../models/JupiterModel";
import PopupPages from "../popupPages/PopupPages";
import UranusModel from "../models/UranusModel";
import MoonModel from "../models/MoonModel";
import EarthModel from "../models/EarthModel";
import SaturnModel from "../models/SaturnModel";
import { galaxyFragmentShader } from "./shaders/galaxyFragmentShader";
import { galaxyVertexShader } from "./shaders/galaxyVertexShader";
import GalaxyModel from "../models/GalaxyModel";

const Galaxy = () => {
    const isSaturnClicked = useSelector((state) => state.planetClickOrNot.saturnClickflag);
    const isEarthClicked = useSelector((state) => state.planetClickOrNot.earthClickflag);
    const isJupiterClicked = useSelector((state) => state.planetClickOrNot.jupiterClickflag);
    const isUranusClicked = useSelector((state) => state.planetClickOrNot.uranusClickflag);
    const saturnInitialValue = useSelector((state) => state.planetClickOrNot.saturnInitialValue);
    const earthInitialValue = useSelector((state) => state.planetClickOrNot.earthInitialValue);
    const jupiterInitialValue = useSelector((state) => state.planetClickOrNot.jupiterInitialValue);
    const uranusInitialValue = useSelector((state) => state.planetClickOrNot.uranusInitialValue);
    const isExploreButtonClicked = useSelector((state) => state.loadingClickOrNot.loadingClick);
    const isExploreButtonInitialValue = useSelector((state) => state.loadingClickOrNot.loadingInitialValue);
    const dispatch = useDispatch();

    const sizes = {
        width: window.innerWidth,
        height: window.innerHeight,
    };

    const particles = useRef();
    const parameters = {};
    parameters.count = 80000;
    parameters.size = 0.1;
    parameters.insideColor = "white";
    parameters.outsideColor = "#1b3984";

    const positions = new Float32Array(parameters.count * 3);

    const colors = new Float32Array(parameters.count * 3);
    const scales = new Float32Array(parameters.count * 1);

    const randomness = new Float32Array(parameters.count * 3);

    const insideColor = new THREE.Color(parameters.insideColor);
    const outsideColor = new THREE.Color(parameters.outsideColor);

    const { gl, camera } = useThree();

    useFrame((state) => {
        if (isExploreButtonClicked === false && isExploreButtonInitialValue === 0) {
            camera.position.x = -20.37;
            camera.position.y = 0.22;
            camera.position.z = -5.42;
        }
    });

    for (let i = 0; i < parameters.count; i++) {
        const i3 = i * 3;
        positions[i3] = (Math.random() - 0.5) * sizes.height * 0.05;
        positions[i3 + 1] = (Math.random() - 0.5) * sizes.width * 0.1;
        positions[i3 + 2] = (Math.random() - 0.5) * sizes.height * 0.1;

        if (isNaN(positions[i]) || isNaN(positions[i + 1]) || isNaN(positions[i + 2])) {
            console.error("Found NaN value at index", i);
        }

        scales[i] = Math.random();

        const mixedColor = insideColor.clone();
        // mixedColor.lerp(outsideColor, radius / parameters.radius);

        colors[i3] = mixedColor.r;
        colors[i3 + 1] = mixedColor.g;
        colors[i3 + 2] = mixedColor.b;
    }

    //     uniform float uSize;
    //     uniform float uTime;

    //     attribute float aScale;
    //     attribute vec3 aRandomness;
    //     varying vec3 vColor;

    //     void main()
    //     {
    //         vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    //         vec4 viewPosition = viewMatrix * modelPosition;
    //         vec4 projectedPosition = projectionMatrix * viewPosition;

    //         gl_Position = projectedPosition;

    //         //randomnize the particle size
    //         gl_PointSize = uSize * aScale;
    //         gl_PointSize *= (1.0 / - viewPosition.z);

    //         vColor = color;
    //     }
    // `;

    // const galaxyFragmentShader = `
    //     varying vec3 vColor;

    //     void main()
    //     {
    //         //Shape
    //         float strength = distance(gl_PointCoord, vec2(0.5));
    //         // strength *= 2.0;
    //         strength = 1.0 - strength;
    //         strength = pow(strength, 5.0);

    //         //Color
    //         vec3 color = mix(vec3(0.0), vColor, strength);

    //         gl_FragColor = vec4(color, 1.0);
    //     }
    // `;

    const uniformData = {
        uSize: { value: 60.0 * gl.getPixelRatio() },
        uTime: { value: 0 },
    };

    const testFunction = () => {
        // href("https://www.google.com.au");
        console.log("testting");
    };

    return (
        <mesh>
            {" "}
            <points ref={particles}>
                <bufferGeometry>
                    <bufferAttribute
                        attach={"attributes-position"}
                        array={positions}
                        itemSize={3}
                        count={parameters.count}
                    />
                    <bufferAttribute attach={"attributes-aScale"} array={scales} itemSize={1} count={scales.length} />
                    <bufferAttribute attach={"attributes-color"} array={colors} itemSize={3} count={colors.length} />
                    <bufferAttribute
                        attach={"attributes-aRandomness"}
                        array={randomness}
                        itemSize={3}
                        count={randomness.length}
                    />
                </bufferGeometry>
                <shaderMaterial
                    depthWrite={false}
                    blending={THREE.AdditiveBlending}
                    vertexColors={true}
                    vertexShader={galaxyVertexShader}
                    fragmentShader={galaxyFragmentShader}
                    uniforms={uniformData}
                />
            </points>
            <JupiterModel
                dispatch={dispatch}
                isSaturnClicked={isSaturnClicked}
                isEarthClicked={isEarthClicked}
                isJupiterClicked={isJupiterClicked}
                isUranusClicked={isUranusClicked}
                isExploreButtonClicked={isExploreButtonClicked}
                saturnInitialValue={saturnInitialValue}
                jupiterInitialValue={jupiterInitialValue}
                earthInitialValue={earthInitialValue}
            />
            <UranusModel
                dispatch={dispatch}
                isSaturnClicked={isSaturnClicked}
                isEarthClicked={isEarthClicked}
                isJupiterClicked={isJupiterClicked}
                isUranusClicked={isUranusClicked}
                isExploreButtonClicked={isExploreButtonClicked}
                saturnInitialValue={saturnInitialValue}
                jupiterInitialValue={jupiterInitialValue}
                earthInitialValue={earthInitialValue}
            />
            <MoonModel
                dispatch={dispatch}
                isSaturnClicked={isSaturnClicked}
                isEarthClicked={isEarthClicked}
                isJupiterClicked={isJupiterClicked}
                isUranusClicked={isUranusClicked}
                isExploreButtonClicked={isExploreButtonClicked}
                saturnInitialValue={saturnInitialValue}
                jupiterInitialValue={jupiterInitialValue}
                earthInitialValue={earthInitialValue}
            />
            <EarthModel
                camera={camera}
                dispatch={dispatch}
                isSaturnClicked={isSaturnClicked}
                isEarthClicked={isEarthClicked}
                isJupiterClicked={isJupiterClicked}
                isUranusClicked={isUranusClicked}
                isExploreButtonClicked={isExploreButtonClicked}
                saturnInitialValue={saturnInitialValue}
                jupiterInitialValue={jupiterInitialValue}
                earthInitialValue={earthInitialValue}
            />
            <GalaxyModel />
            <SaturnModel
                camera={camera}
                dispatch={dispatch}
                isSaturnClicked={isSaturnClicked}
                isEarthClicked={isEarthClicked}
                isJupiterClicked={isJupiterClicked}
                isUranusClicked={isUranusClicked}
                isExploreButtonClicked={isExploreButtonClicked}
                saturnInitialValue={saturnInitialValue}
                jupiterInitialValue={jupiterInitialValue}
                earthInitialValue={earthInitialValue}
            />
            <Html position={isSaturnClicked ? [-7, 2.5, 0] : [0, 0, -1000]}>
                <PopupPages
                    isSaturnClicked={isSaturnClicked}
                    onClickFunction={testFunction}
                    dispatch={dispatch}
                    content={"What We Do"}
                />
            </Html>
            <Html position={isEarthClicked ? [-7, 2.5, 0] : [0, 0, -1000]}>
                <PopupPages
                    isEarthClicked={isEarthClicked}
                    onClickFunction={null}
                    dispatch={dispatch}
                    content={"About us"}
                />
            </Html>
            <Html position={isJupiterClicked ? [-7, 2.5, 0] : [0, 0, -1000]}>
                <PopupPages
                    isJupiterClicked={isJupiterClicked}
                    onClickFunction={null}
                    dispatch={dispatch}
                    content={"Contact us"}
                />
            </Html>
            <Html position={isUranusClicked ? [-7, 2.5, 0] : [0, 0, -1000]}>
                <PopupPages
                    isUranusClicked={isUranusClicked}
                    onClickFunction={null}
                    dispatch={dispatch}
                    content={"Work/Services"}
                />
            </Html>
            <Html position={[-1.25, 3.5, 0]} style={isExploreButtonClicked ? { opacity: "1" } : { opacity: "0" }}>
                <div className="topTitle">Ipomoea</div>
            </Html>
        </mesh>
    );
};

export default Galaxy;
